import React, { useState } from 'react';
import History from '../../utils/BrowserHistory';
import ButtonRound from '../ButtonRound';
import styles from './CreateValuationTeaser.scss';
import ValuationWidget from './ValuationWidget';
import TeaserImgSrc from '../../assets/img/Rike/Bild1.jpg';
import OracleSvg from '../../assets/img/house_oracle.svg';

export interface ICreateValuationTeaserProps {
    className?: string;
}

const CreateValuationTeaser: React.FC<React.PropsWithChildren<ICreateValuationTeaserProps>> = ({ className = '' }) => {
    const [showTeaser, setShowTeaser] = useState<boolean>(true);

    React.useEffect(() => {
        const unlisten = History.listen(({ location, action }) => {
            const step = location.hash ? parseInt(location.hash.replace('#step', '')) : 0;
            if (step === 0) {
                setShowTeaser(true);
            } else if (step === 1) {
                setShowTeaser(false);
            }
        });
        return unlisten;
    }, []);

    const handleButtonClick = () => {
        setShowTeaser(false);
    };

    return (
        <>
            {showTeaser ? (
                <div className={styles.createValuationTeaser + ' ' + className}>
                    <div className={styles.content}>
                        <h2>Du besitzt eine Immobilie?</h2>
                        <p>
                            Dann nutze unser <u>Eigentümer-Dashboard</u>!
                        </p>
                        <ul>
                            <li>Fortlaufender Überblick über Wert und Wertentwicklung Deiner Immobilie</li>
                            <li>Aktuelle Informationen zu Bauvorhaben in Deiner Umgebung</li>
                            <li>Immobilienangebot und -nachfrage in Deiner Nachbarschaft</li>
                        </ul>

                        <div className={styles.actions}>
                            <ButtonRound onClick={handleButtonClick} size="medium">
                                Jetzt alles über Deine Immobilie erfahren
                            </ButtonRound>

                            <ButtonRound type="link" size="medium" color="whiteRed" href="/dein-eigentuemer-dashboard-so-entwickelt-sich-deine-immobilie">
                                Mehr Erfahren
                            </ButtonRound>
                        </div>
                    </div>
                    <div className={styles.image}>
                        <img src={TeaserImgSrc} />
                        <OracleSvg />
                    </div>
                </div>
            ) : (
                <ValuationWidget variant="dashboard" startStep={1} />
            )}
        </>
    );
};

export default CreateValuationTeaser;
